import request from "../utils/request";
import { APP_API_BASE_URL } from "../utils/env"

 const orderApi = {
    //  服务包工单列表
    OrderList: `${APP_API_BASE_URL}nurse/order/reserve/system`,
    //  服务包接单
    OrderTaskDo: `${APP_API_BASE_URL}nurse/order/reserve/do/order`,
    //  服务包处理取消申请
    OrderTaskCancel: `${APP_API_BASE_URL}nurse/order/reserve/approval`,
    // 服务包工单详情
    OrderDetail: `${APP_API_BASE_URL}nurse/order/reserve/detail/`,
    // 问卷列表查询
    QuesList: `${APP_API_BASE_URL}nurse/question`,
    // 问卷新增
    QuesAdd: `${APP_API_BASE_URL}nurse/question/add`,
    // 问卷详情
    QuesDetail: `${APP_API_BASE_URL}nurse/question/detail`,
    // 问卷编辑
    QuesEdit: `${APP_API_BASE_URL}nurse/question/edit`,
    // 问卷删除
    QuesRemove: `${APP_API_BASE_URL}nurse/question/remove/`
 }

 // 查询服务包工单列表
 export function getOrderList(parameter) {
    return request({
      url: orderApi.OrderList,
      method: 'get',
      params: parameter
    })
  }
// 服务包工单接单
export function getOrderTaskDo(parameter) {
  return request({
    url: orderApi.OrderTaskDo,
    method: 'post',
    data: parameter
  })
}
// 服务包工单详情
export function getOrderDetail(id) {
  return request({
    url: orderApi.OrderDetail + id,
    method: 'get'
  })
}
// 处理取消申请

export function getOrderTaskCancel(parameter) {
  return request({
    url: orderApi.OrderTaskCancel,
    method: 'post',
    data: parameter
  })
}
// 问卷列表查询
export function getQuesList(parameter) {
    return request({
      url: orderApi.QuesList,
      method: 'get',
      params: parameter
    })
  }
// 问卷新增
export function getQuesAdd(data) {
    return request({
      url: orderApi.QuesAdd,
      method: 'post',
      data
    })
  }
// 问卷编辑
export function getQuesEdit(data) {
    return request({
      url: orderApi.QuesEdit,
      method: 'post',
      data
    })
  }
// 问卷详情
export function getQuesDetail(id) {
    return request({
      url: orderApi.QuesDetail + id,
      method: 'get'
    })
  }
// 问卷删除  
export function getQuesRemove(id) {
    return request({
      url: orderApi.QuesRemove + id,
      method: 'post'
    })
  }